import React from 'react';
import { objectsConstants as OC } from 'redux/constant/objects-constant';
import SimpleReactValidator from 'simple-react-validator';
import Select from 'react-select';
import { IoMdAdd } from 'react-icons/io'


const createSelectOption = (label) => {
    if (label) {
        return {
            title: label,
            value: label,
        }
    }
    else {
        return ''
    }
};

class ExportAttributeForm extends React.Component {
    constructor(props) {
        super(props);
        this.valitdatorList = new SimpleReactValidator({ autoForceUpdate: this, locale: 'en' });
        this.state = {
            exportable_attributes: [
                ...this.props.exportableAttributesDropdown,
            ],
            submitted: false,
            formType: this.props.formTypePro || '',
            duplicate_error: false,
            export_attribute: {
                ...this.props.export_attribute
            }
        };
        this.handleList = this.handleList.bind(this);
        this.handleListSubmitForm = this.handleListSubmitForm.bind(this);
    }
    handleList(e) {
        const { name, value } = e.target;
        this.setState(prevState => ({
            exportable_attributes: {
                ...prevState.exportable_attributes,
                [name]: value
            }
        }));
    }

    hanldleChangeDropdown = (selectedOption, name) => {
        if (name.action === 'select-option') {
            this.setState({
                export_attribute: {
                    title: selectedOption.title,
                    db_column: selectedOption.value,
                    attribute_type: selectedOption.attribute_type,
                }
            })
        }
    }

    onInputHandler = (e) => {
        this.setState({
            export_attribute: {
                ...this.state.export_attribute,
                [e.target.name]: e.target.value
            }
        });
    }
    handleListSubmitForm(e) {
        e.preventDefault();
        if (this.valitdatorList.allValid()) {
            this.setState({
                submitted: true
            }, function () {
                this.props.handleSubmit(this.state.export_attribute, this.state.formType);
                this.setState({
                    export_attribute: {
                        title: '',
                        db_column: '',
                        attribute_type: '',
                        header_label: '',
                    },
                    submitted: false,
                    formType: this.props.formTypePro || '',
                    duplicate_error: false,
                })
            });
        } else {
            this.setState({ submitted: false });
            this.valitdatorList.showMessages();
            this.forceUpdate();
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.exportable_attributes !== prevState.exportable_attributes && this.state.duplicate_error) {
            if (this.state.exportable_attributes.title !== prevState.exportable_attributes.title) {
                this.setState({
                    duplicate_error: false
                })
            }
        }

        if (this.props.exportableAttributesDropdown !== prevProps.exportableAttributesDropdown) {
            this.setState({
                exportable_attributes: this.props.exportableAttributesDropdown
            })
        }

        if (this.props.export_attribute !== prevProps.export_attribute) {
            this.setState({
                export_attribute: OC.export_attribute
            })
        }
    }

    handleButtonClick = () => {
        if (this.valitdatorList.allValid()) {
            this.props.handleSubmit(this.state.export_attribute, this.state.formType);
            this.setState({
                export_attribute: {
                    title: '',
                    db_column: '',
                    attribute_type: '',
                    header_label: '',
                },
                submitted: false,
                formType: this.props.formTypePro || '',
                duplicate_error: false,
            })
            this.valitdatorList.hideMessages();
        } else {
            this.setState({ submitted: false });
            this.valitdatorList.showMessages();
            this.forceUpdate();
        }
    }
    render() {
        const { exportable_attributes, export_attribute } = this.state;
        this.valitdatorList.purgeFields();
        return (
            <tr style={{ backgroundColor: "#d2dfeb" }}>
                <td>{this.props.attributesLength}</td>
                <td>
                    <Select
                        value={createSelectOption(export_attribute.title)}
                        onChange={this.hanldleChangeDropdown}
                        options={exportable_attributes}
                        isSearchable={true}
                        name={'exportable_attribute'}
                        getOptionLabel={option => option.title}
                        getOptionValue={option => option.title}
                        isMulti={false}
                        placeholder={'Select Attribute'}
                        isClearable={false}
                    />
                    {this.state.duplicate_error && <span style={{ color: 'red' }}>Title already exists in the list.</span>}
                    {this.valitdatorList.message('Title', export_attribute.title, 'required')}
                </td>

                <td>
                    <div></div>
                    <div className=" text-capitalize">{export_attribute.attribute_type ? export_attribute.attribute_type : 'Product/Order'}</div>
                </td>

                <td>
                    <input type="text" name="header_label" className="form-control" value={export_attribute.header_label ? export_attribute.header_label : ''} onChange={this.onInputHandler} />
                </td>

                <td>
                    <button className="customBtn btnBlue btnRounded" type='button' onClick={this.handleButtonClick}><IoMdAdd /></button>
                </td>
            </tr>
        );
    }
}


export default ExportAttributeForm;



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/ExportAttributeForm.jsx